import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isTypes, withFragments } from '#src/lib/gql/index.ts';

import type { getAccountIdentifier_bankAccount } from './__generated__/utils.graphql.ts';

export const getAccountIdentifier = withFragments(
  (bankAccount_: getAccountIdentifier_bankAccount) => {
    const bankAccount = bankAccount_;
    if (
      isTypes(bankAccount, [
        'CaBankAccount',
        'UsBankAccount',
        'GbBankAccount',
        'OtherBankAccount',
      ])
    ) {
      return `•••• ${bankAccount.accountNumber}`;
    }

    return bankAccount.iban.replace(
      bankAccount.iban.substring(
        bankAccount.iban.indexOf('#'),
        bankAccount.iban.lastIndexOf('#') + 1
      ),
      ' •••• '
    );
  },
  {
    bankAccount: gql`
      fragment getAccountIdentifier_bankAccount on BankAccount {
        ... on CaBankAccount {
          id
          accountNumber
        }
        ... on UsBankAccount {
          id
          accountNumber
        }
        ... on GbBankAccount {
          id
          accountNumber
        }
        ... on OtherBankAccount {
          id
          accountNumber
        }
        ... on IbanBankAccount {
          id
          iban
        }
      }
    ` as TypedDocumentNode<getAccountIdentifier_bankAccount>,
  }
);
